import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { ElevatedButton } from 'components/layout'
import styles from './footer.styl'

export default class MaterialModalFooter extends Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    insideContent: PropTypes.bool,
    action: PropTypes.string,
    actionKey: PropTypes.string,
    colorClass: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    insideContent: false
  }

  render() {
    const {
      action,
      actionKey,
      isLoading,
      colorClass,
      insideContent,
      onClick,
      disabled
    } = this.props

    const classNames = [styles.footer]

    insideContent && classNames.push(styles.insideContent)

    const params = {
      onClick,
      disabled
    }

    return (
      <div className={classNames.join(' ')}>
        <div className={styles.submit}>
          <ElevatedButton
            colorClass={colorClass}
            isLoading={isLoading}
            intlKey={actionKey}
            uppercase
            rounded
            submit={!onClick}
            {...params}
          >
            {action}
          </ElevatedButton>
        </div>
      </div>
    )
  }
}
